import images from './images';

const kolejWaskotorowaData = {
    title: 'kolejWaskotorowa.title',
    breadcrumb: 'kolejWaskotorowa.breadcrumb',
    facebookUrl: 'https://www.facebook.com/kolejkrosniewice?locale=pl_PL',
    overview: {
        subtitle: 'kolejWaskotorowa.overview.subtitle',
        intro: 'kolejWaskotorowa.overview.intro',
        cards: [
            {
                id: 1,
                title: 'kolejWaskotorowa.overview.cards.0.title',
                text: 'kolejWaskotorowa.overview.cards.0.text',
                link: '/Kolej-Waskotorowa/Historia',
            },
            {
                id: 2,
                title: 'kolejWaskotorowa.overview.cards.1.title',
                text: 'kolejWaskotorowa.overview.cards.1.text',
                link: '/Kolej-Waskotorowa/Towarzystwo',
            },
            {
                id: 3,
                title: 'kolejWaskotorowa.overview.cards.2.title',
                text: 'kolejWaskotorowa.overview.cards.2.text',
                link: '/Kolej-Waskotorowa/Galeria',
            },
        ],
    },
    manifest: {
        title: 'kolejWaskotorowa.manifest.title',
        subtitle: 'kolejWaskotorowa.manifest.subtitle',
        lead: 'kolejWaskotorowa.manifest.lead',
        pointss: [
            'kolejWaskotorowa.manifest.points.0',
            'kolejWaskotorowa.manifest.points.1',
            'kolejWaskotorowa.manifest.points.2',
            'kolejWaskotorowa.manifest.points.3',
        ],
        closing: 'kolejWaskotorowa.manifest.closing',
    },
    history: {
        title: 'kolejWaskotorowa.history.title',
        subtitle: 'kolejWaskotorowa.history.subtitle',
        intro: 'kolejWaskotorowa.history.intro',
        timeline: [
            {
                id: 1,
                phase: 'kolejWaskotorowa.history.timeline.0.phase',
                title: 'kolejWaskotorowa.history.timeline.0.title',
                text: 'kolejWaskotorowa.history.timeline.0.text',
                image: images.history1,
                caption: 'kolejWaskotorowa.history.timeline.0.caption'
            },
            {
                id: 2,
                phase: 'kolejWaskotorowa.history.timeline.1.phase',
                title: 'kolejWaskotorowa.history.timeline.1.title',
                text: 'kolejWaskotorowa.history.timeline.1.text',
                image: images.history2,
                caption: 'kolejWaskotorowa.history.timeline.1.caption'
            },
            {
                id: 3,
                phase: 'kolejWaskotorowa.history.timeline.2.phase',
                title: 'kolejWaskotorowa.history.timeline.2.title',
                text: 'kolejWaskotorowa.history.timeline.2.text',
                image: images.history3,
                caption: 'kolejWaskotorowa.history.timeline.2.caption'
            },
            {
                id: 4,
                phase: 'kolejWaskotorowa.history.timeline.3.phase',
                title: 'kolejWaskotorowa.history.timeline.3.title',
                text: 'kolejWaskotorowa.history.timeline.3.text',
                image: images.kolej4,
                caption: 'kolejWaskotorowa.history.timeline.3.caption'
            },
            {
                id: 5,
                phase: 'kolejWaskotorowa.history.timeline.4.phase',
                title: 'kolejWaskotorowa.history.timeline.4.title',
                text: 'kolejWaskotorowa.history.timeline.4.text',
                image: images.kolej5,
                caption: 'kolejWaskotorowa.history.timeline.4.caption'
            },
            {
                id: 6,
                phase: 'kolejWaskotorowa.history.timeline.5.phase',
                title: 'kolejWaskotorowa.history.timeline.5.title',
                text: 'kolejWaskotorowa.history.timeline.5.text',
                image: images.kolej6,
                caption: 'kolejWaskotorowa.history.timeline.5.caption'
            },
        ],
    },
    society: {
        title: 'kolejWaskotorowa.society.title',
        subtitle: 'kolejWaskotorowa.society.subtitle',
        intro: 'kolejWaskotorowa.society.intro',
        blocks: [
            {
                id: 1,
                title: 'kolejWaskotorowa.society.blocks.0.title',
                text: 'kolejWaskotorowa.society.blocks.0.text',
            },
            {
                id: 2,
                title: 'kolejWaskotorowa.society.blocks.1.title',
                text: 'kolejWaskotorowa.society.blocks.1.text',
            },
            {
                id: 3,
                title: 'kolejWaskotorowa.society.blocks.2.title',
                text: 'kolejWaskotorowa.society.blocks.2.text',
            },
        ],
    },
    gallery: {
        title: 'kolejWaskotorowa.gallery.title',
        subtitle: 'kolejWaskotorowa.gallery.subtitle',
        intro: 'kolejWaskotorowa.gallery.intro',
        images: [
            images.kolej1,
            images.kolej2,
            images.kolej3,
            images.kolej4,
            images.kolej5,
            images.kolej6,
            images.kolej7,
            images.kolej8,
            images.kolej9,
            images.kolej10,
            images.kolej11,
            images.kolej12,
            images.kolej13,
            images.kolej14,
            images.kolej15,
            images.kolej16,
            images.kolej17,
            images.kolej18,
        ],
        highlightss: [
            'kolejWaskotorowa.gallery.highlights.0',
            'kolejWaskotorowa.gallery.highlights.1',
            'kolejWaskotorowa.gallery.highlights.2',
            'kolejWaskotorowa.gallery.highlights.3',
        ],
    },
};

export default kolejWaskotorowaData;